<template>
  <div class="container">
      <LoadingSpinner :loading="loading"> </LoadingSpinner>

      <div class="mt-4">
        <h3>Kontantbeholdning</h3>

        <div v-if="!loading">
            <div style="max-width:545px">
              <div v-if="hasMultiLocations()" class="mt-4">
                <span class="ingredient-title">Velg avdeling</span>
                <select class="form-select" v-model="locationId" @change="showTerminals()">
                  <option v-for="(location, index) in locations" :key="index" :value="location.id">{{ location.name }}</option>
                </select>
              </div>

              <div v-if="terminals.length > 0">
                  <SelectTerminal :terminals="terminals" :terminal="selectedTerminal" @setSelectedTerminal="setSelectedTerminal"/>

                  <SelectDate ref="selectDateFrom" label="Velg fra og med dato" :selectedDate="fromDateString"/>
                  <SelectDate ref="selectDateTo" label="Velg til og med dato" :selectedDate="toDateString"/>

                  <button type="button" class="bo_btn mt-3" :class="zReports.length == 0 ? 'mb-5' : 'mb-0'" @click="showReport"> Vis kontantbeholdning </button>

                  <div v-if="zReports.length == 0 && resultFetched" class="xz-report mb-5">
                    <p class="no-report-found">Ingen data funnet.</p>
                  </div>
              </div>
            </div>

            <ShowCashHoldingReport v-if="zReports.length > 0" :zReports="zReports" :terminals="terminals" />
        </div>
      </div>
  </div>
</template>

<script>
  import LoadingSpinner from "@/components/other/LoadingSpinner";
  import SelectDate from "@/components/other/SelectDate";
  import ShowCashHoldingReport from "@/components/report/cashholding/ShowCashHoldingReport";
  import ReportService from "@/services/report/ReportService";
  import LocationUtil from "@/util/LocationUtil";
  import TerminalService from "@/services/terminal/TerminalService";
  import TerminalVisibility from "@/util/TerminalVisibility";
  import SelectTerminal from "@/components/report/SelectTerminal";
  import moment from "moment";

  export default {
    components: {LoadingSpinner, SelectTerminal, SelectDate, ShowCashHoldingReport},
    data() {
      return {
        loading: true,

        locationId: '',
        locations: [],
        merchant: '',
        terminals: [],
        selectedTerminal: {},
        fromDate: new Date(),
        toDate: new Date(),
        fromDateString: moment().format('YYYY-MM-DD'),
        toDateString: moment().format('YYYY-MM-DD'),
        zReports: [],
        resultFetched: false
      };
    },
    mounted() {
      ReportService.getDataForReportGui().then(
          (response) => {
            let dataForGui = response.data;
            this.merchant = dataForGui.merchant;
            this.locations = dataForGui.locations;
            this.locationId = this.locations.length ? this.locations[0].id : '';
            this.showTerminals();
          },
          (error) => {
            console.log(error);
          }
      );
    },
    methods: {
      hasMultiLocations(){
        return LocationUtil.hasMultiLocations();
      },
      showTerminals() {
        this.loading = true;
        this.zReports = [];
        this.resultFetched = false;

        TerminalService.getTerminalsForLocation(this.locationId).then(
            (response) => {
              let filteredTerminals = [];

              // A terminal SUPER_ADMIN hid from the merchant (a test till) is left out for everyone else.
              let availableTerminals = TerminalVisibility.forMerchantView(response.data);
              let cashTerminals = [];
              for(let i = 0; i < availableTerminals.length; i++) {
                if(availableTerminals[i].offerCashPayment){
                  cashTerminals.push(availableTerminals[i]);
                }
              }

              if(cashTerminals.length > 1){
                filteredTerminals.push({
                  terminalId: 'ALL',
                  locationId: this.locationId
                });
              }
              filteredTerminals = filteredTerminals.concat(cashTerminals);

              this.terminals = filteredTerminals;
              this.selectedTerminal = this.terminals.length > 0 ? this.terminals[0] : {};

              this.loading = false;
            },
            (error) => {
              console.log(error);
            }
        );
      },
      setSelectedTerminal(terminal){
        this.selectedTerminal = terminal;
        this.zReports = [];
        this.resultFetched = false;
      },
      showReport() {
        this.loading = true;
        this.fromDateString = this.$refs.selectDateFrom.getSelectedDate();
        this.toDateString = this.$refs.selectDateTo.getSelectedDate();
        this.fromDate = moment(this.fromDateString, 'YYYY-MM-DD').toDate();
        this.toDate = moment(this.toDateString, 'YYYY-MM-DD').toDate();

        ReportService.getTotalSalesReport(this.locationId, this.selectedTerminal.terminalId, this.fromDateString, this.toDateString).then(
            (response) => {
              if(response.data){
                  this.zReports = response.data.sort((a, b) => {
                    let dataA = a.cagistahospitality || a;
                    let dataB = b.cagistahospitality || b;
                    return new Date(dataA.createdTime) - new Date(dataB.createdTime);
                  });
              } else {
                  this.zReports = [];
              }

              this.loading = false;
              this.resultFetched = true;
            },
            (error) => {
              console.log(error);
            }
        );
      }
    }
  };
</script>
